const o=":host,:root{--ngc-tooltip-background-color: var(--color-neutral-70, #1F1F1F);--ngc-tooltip-color: var(--color-grey-10, #FFF) }";export{o as default};
